import React, { createContext, useState, useContext } from "react";

// Create the context
export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // Load user from localStorage
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("travelo_user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (err) {
      console.error("Failed to parse stored user:", err);
      return null;
    }
  });

  // Load token from localStorage
  const [token, setToken] = useState(() => {
    try {
      return localStorage.getItem("travelo_token") || null;
    } catch (err) {
      console.error("Failed to load token:", err);
      return null;
    }
  });

  // Save user + token to state and localStorage
  function saveUser(userObj, tokenValue) {
  setUser(userObj);
  if (tokenValue !== undefined) {
    setToken(tokenValue);
    localStorage.setItem("travelo_token", tokenValue);
  }
  try {
    localStorage.setItem("travelo_user", JSON.stringify(userObj));
  } catch (err) {
    console.error("Failed to save user to localStorage:", err);
  }
}

  // Clear user + token from state and localStorage
  function clearUser() {
    setUser(null);
    setToken(null);
    try {
      localStorage.removeItem("travelo_user");
      localStorage.removeItem("travelo_token");
    } catch (err) {
      console.error("Failed to clear user from localStorage:", err);
    }
  }

  return (
    <AuthContext.Provider value={{ user, token, saveUser, clearUser }}>
      {children}
    </AuthContext.Provider>
  );
}

// ✅ Custom hook to consume AuthContext
export function useAuth() {
  return useContext(AuthContext);
}